// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bio-card .content {
  position: relative;
  cursor: pointer;
  background: transparent;
  overflow: visible;
  padding: 0 44px 0 0;
}
.bio-card .content p {
  margin: 0;
  font-size: 14px;
  color: var(--gray_dark2);
  white-space: pre-line;
}
.bio-card .content p.one-line-bio {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.bio-card .content:after {
  content: " ";
  position: absolute;
  top: 4px;
  right: 16px;
  border-width: 0 3px 3px 0;
  border-color: var(--gray_dark1);
  border-style: solid;
  padding: 5px;
  transform: rotate(45deg);
  z-index: 10;
  transform-origin: center center;
}
.bio-card .content.open:after {
  top: 10px;
  transform: rotate(-135deg);
}`, "",{"version":3,"sources":["webpack://./src/components/BioCard/index.scss"],"names":[],"mappings":"AACE;EACE,kBAAA;EACA,eAAA;EACA,uBAAA;EACA,iBAAA;EACA,mBAAA;AAAJ;AACI;EACE,SAAA;EACA,eAAA;EACA,wBAAA;EACA,qBAAA;AACN;AAAM;EACE,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;AAER;AACI;EACE,YAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,yBAAA;EACA,+BAAA;EACA,mBAAA;EACA,YAAA;EACA,wBAAA;EACA,WAAA;EACA,+BAAA;AACN;AAGM;EACE,SAAA;EACA,0BAAA;AADR","sourcesContent":[".bio-card {\n  .content {\n    position: relative;\n    cursor: pointer;\n    background: transparent;\n    overflow: visible;\n    padding: 0 44px 0 0;\n    p {\n      margin: 0;\n      font-size: 14px;\n      color: var(--gray_dark2);\n      white-space: pre-line;\n      &.one-line-bio {\n        display: -webkit-box;\n        -webkit-line-clamp: 1;\n        -webkit-box-orient: vertical;\n        overflow: hidden;\n      }\n    }\n    &:after {\n      content: ' ';\n      position: absolute;\n      top: 4px;\n      right: 16px;\n      border-width: 0 3px 3px 0;\n      border-color: var(--gray_dark1);\n      border-style: solid;\n      padding: 5px;\n      transform: rotate(45deg);\n      z-index: 10;\n      transform-origin: center center;\n    }\n\n    &.open {\n      &:after {\n        top: 10px;\n        transform: rotate(-135deg);\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
